import React from 'react';

import { useAppSelector } from '~/store';
import { selectGenerateContentLimits } from '~/ai/state/aiLimits/slice';
import WarningIcon from '@bufferapp/ui/Icon/Icons/Warning';

import * as Styled from './styles';

/**
 *
 */
const Credits = ({ onUpgrade }: { onUpgrade: () => void }) => {
  const { generateContentTokensLeft, limitsLoaded } = useAppSelector((state) =>
    selectGenerateContentLimits(state)
  );

  const highlightButton = generateContentTokensLeft === 0;

  return limitsLoaded ? (
    <Styled.Wrapper>
      {generateContentTokensLeft === 0 ? (
        <Styled.NoCreditsLeft>
          <WarningIcon />
          You&apos;ve used all your AI credits.
        </Styled.NoCreditsLeft>
      ) : (
        `You have ${generateContentTokensLeft} AI Credits left.`
      )}
      <Styled.UpgradeButton onClick={onUpgrade} highlighted={highlightButton}>
        Get more AI Credits.
      </Styled.UpgradeButton>
    </Styled.Wrapper>
  ) : null;
};

export { Credits };
